<template>
  <div class="form-group">
    <input
      :id="elementId"
      :type="elementType"
      :name="elementName"
      class="form-control w-100 text-xl text-center border-success"
      onfocus="{ this.value = ''; }"
      :placeholder="elementPlaceholder"
      :value="amount"
      @class="elementClass"
      @paste="onPaste($event)"
      @keypress="validateNumber($event)"
      @keyup="updateAmount($event)"
    >
  </div>
</template>

<script>
export default {
  name: 'CashInput',
  props: {
    elementId: {
      type: String,
      default: '',
    },
    elementName: {
      type: String,
      default: '',
    },
    elementType: {
      type: String,
      default: '',
    },
    elementLabel: {
      type: String,
      default: '',
    },
    elementTitle: {
      type: String,
      default: '',
    },
    elementClass: {
      type: String,
      default: '',
    },
    elementPlaceholder: {
      type: String,
      default: '',
    },
    amount: {
      type: [String, Number],
      default: '',
    },
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {
    validateNumber: (evt) => {
      evt = evt || window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31
        && (charCode < 48 || charCode > 57)
        && charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    updateAmount(evt) {
      let val = evt.target.value;
      if (val == 'NaN' || val == '') {
        val = 0;
      }

      this.$emit('updateAmountValue', parseInt(val));
    },
    onPaste: (evt) => {
      evt.preventDefault();
    },
  },
};
</script>
